import type { FC } from 'react';
import type { GlycerinWishListProduct } from '@packages/tracking/src/types/types';
import type { WishlistButtonWithApiProps } from '../WishlistButtonWithApi/WishlistButtonWithApi';
import { WishlistButtonWithApi } from '../WishlistButtonWithApi/WishlistButtonWithApi';

export type ReducedGlycerinWishlistProduct = Omit<
  GlycerinWishListProduct,
  'skuId' | 'availability'
>;

interface ProductCardV2WishlistButtonProps {
  productName: string;
  sku: string;
  size?: 'medium' | 'large';
  wishListTrackingProps: WishlistButtonWithApiProps['trackingProps'];
}

export const ProductCardV2WishlistButton: FC<ProductCardV2WishlistButtonProps> = ({
  productName,
  sku,
  size = 'large',
  wishListTrackingProps,
}) => (
  // TODO remove hover:* and transition once the wishlist button has proper hover styling
  <div className="product-card-wishlist-button hover:bg-color-text-lighttransparent focus-within:standard-focus-outline relative z-10 m-[1px] self-start justify-self-end transition-colors [grid-area:1/2/span_1/span_1]">
    <WishlistButtonWithApi
      productName={productName}
      sku={sku}
      size={size}
      availability="UNSELECTED"
      trackingProps={wishListTrackingProps}
    />
  </div>
);
